import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class PhotoSectionsService extends Service {
  path = 'parametrizacaosecaofoto'

  async get(payload: any) {
    const httpResponse = this.httpClient.get(`${this.path}`, {
      params: removePropertyEmpty(payload),
    })
    return httpResponse
  }

  async getById(id: string) {
    const httpResponse = this.httpClient.get(`${this.path}/${id}`)
    return httpResponse
  }

  async export(payload: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/excel`, {
      params: removePropertyEmpty(payload),
    })
    return httpResponse
  }

  async post(payload: any) {
    const httpResponse = await this.httpClient.post(this.path, payload)
    return httpResponse
  }

  async put(id: string, payload: any) {
    const httpResponse = await this.httpClient.put(
      `${this.path}?id=${id}`,
      payload,
    )
    return httpResponse
  }

  async inactive(id: string) {
    const httpResponse = await this.httpClient.delete(this.path, {
      params: { id },
    })
    return httpResponse
  }

  async active(id: string) {
    const httpResponse = await this.httpClient.put(`${this.path}/ativar?id=${id}`)
    return httpResponse
  }
}

export const photoSectionsService = new PhotoSectionsService()
